import { createContext, useContext } from 'react';
export const DndComponentsCtxt = /*#__PURE__*/createContext(null);

/**
 *  @deprecated This hook should not be used as we have deprecated nova-commons react-beautiful-dnd fork. Use [useReactDndConstructs()] instead.
 */
export function useDragAndDropComponents() {
  return useContext(DndComponentsCtxt);
}
//# sourceMappingURL=DndComponentsContext.js.map